import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UserNewsState = {
  news: null,
  newsLoading: false,
  newsSeen: true,
}

export const UserNewsActions = {
  async fetchNews ({ commit }) {
    commit('setNewsLoading', true)
    return axiosRequest.get('/users/news').
      then(({ data }) => {
        commit('setNews', data.news)
      }).
      catch(handleError).
      finally(_ => commit('setNewsLoading', false))
  },

  async markNewsAsSeen ({ commit }) {
    return axiosRequest.patch('/users/news/mark_as_seen').
      then(({ data }) => {
        commit('setNewsSeen', data.seen)
      }).
      catch(handleError)
  },
}

export const UserNewsMutations = {
  setNews (state, news) { state.news = news },
  setNewsLoading (state, loading) { state.newsLoading = loading },
  setNewsSeen (state, seen) { state.newsSeen = seen },
}

export const UserNewsGetters = {
  news: state => state.news,
  newsLoading: state => state.newsLoading,
  newsSeen: state => state.newsSeen,
}
